module.exports = __webpack_public_path__ + "img/신사 미용실.ccde656d.png";